import { useCurrency } from '@/hooks/react-currency-hook';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import React from 'react';

export const AmountInput = ({ disabled, hasError, value, setValue }: { disabled?: boolean, hasError?: boolean, value?: string, setValue: (value: string) => void }) => {
    const { onChange, toNumber, format } = useCurrency({ currency: 'USD', locale: 'en-US', precision: 0, negative: 'never' });

    return (
        <div className={clsx('relative flex justify-between flex-col mb-4 mt-2 py-2 items-center')}>
            <motion.input
                animate={{ borderColor: hasError ? '#D92D20' : '#D0D5DD', color: hasError ? '#D92D20' : '#000000' }}
                placeholder="$12,345"
                style={{ borderBottom: '1px solid #D0D5DD' }}
                disabled={disabled}
                onChange={(e) => {
                    onChange(e);
                    setValue(toNumber(e.target.value).toFixed(2));
                }}
                value={format(Number(value).toFixed(0).toString() ?? '0')}
                className={clsx('w-full text-center text-[24px] font-[500] pb-[5px] bg-transparent')}
                autoFocus
            />
        </div>
    );
};
